import * as types from "../actions/actionsTypes";
import {AUTH_REFRESH} from "../actions/actionsTypes";

let initialState = {
  access_token: null,
  refresh_token: null,
  remember_email: "",
  remember_password: "",
  expire_date: 0,
  refreshing: 0,
  expires_in: 0,
  locale: "fr",
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.AUTH_SET_TOKEN:
      return {
        ...state,
        access_token: action.data.access_token,
        refresh_token: action.data.refresh_token,
        expire_date: action.data.expire_date,
        expires_in: action.data.expires_in,
        refreshing: 0,
      };

    case types.AUTH_DEL_TOKEN:
      return {
        ...state,
        access_token: null,
        refresh_token: null,
        expires_in: 0,
        expire_date: 0,
      };

    case types.AUTH_SET_REMEMBER_ME:
      return {
        ...state,
        remember_email: action.data.email,
        remember_password: action.data.password,
      };

    case types.AUTH_DEL_REMEMBER_ME:
      return {
        ...state,
        remember_email: "",
        remember_password: "",
        expires_in: 0,
        refreshing: 0,
      };

    case types.AUTH_START_REFRESH:
      return {
        ...state,
        refreshing: 1,
      };

    case types.AUTH_END_REFRESH:
      return {
        ...state,
        refreshing: 0,
      };

    case types.AUTH_SET_LOCALE:
      return {
        ...state,
        locale: action.data,
      };

    case types.AUTH_RESET_LOCALE:
      return {
        ...state,
        locale: "fr",
      };

    default:
      return state;
  }
};

export default authReducer;
